import {StorageHelper, StorageKeys} from 'utils';

export class UserHelper {
  public static isLoggedIn() {
    const token = UserHelper.getToken();
    return !!token;
  }

  public static isAdminUser(){
    const user = StorageHelper.get(StorageKeys.User);
    return !!(user?.isAdmin)
  }

  public static getToken() {
    return StorageHelper.get(StorageKeys.Token);
  }

  public static getUserData() {
    return StorageHelper.get(StorageKeys.User);
  }

  public static getSizingReportId() {
    return StorageHelper.get(StorageKeys.SizingReportId);
  }


  public static storeSizingReportId(sizingReportId: string) {
    StorageHelper.set(StorageKeys.SizingReportId, sizingReportId);
  }
  public static storeContainerId(containerId: string) {
    StorageHelper.set(StorageKeys.containerId, containerId);
  }


  public static storeUserData(
    token: string,
    user: any,
    expirationTime: number,
    refreshToken: string,
    refreshExpiration: string,
    sizingReportIdExist: boolean
  ) {
    StorageHelper.set(StorageKeys.Token, token);
    StorageHelper.set(StorageKeys.User, user);
    StorageHelper.set(StorageKeys.expireToken, expirationTime);
    StorageHelper.set(StorageKeys.refreshToken, refreshToken)
    StorageHelper.set(StorageKeys.refreshExpiration, refreshExpiration)

    if (sizingReportIdExist) StorageHelper.remove(StorageKeys.SizingReportId);
  }

  // public static logoutUser() {
  //   StorageHelper.clear();
  // }
  public static logoutUser() {
    const language = StorageHelper.get('language');
    StorageHelper.clear(); 
    if (language) {
      StorageHelper.set('language', language);
    }
  }

  public static getRegions() {
    return StorageHelper.get(StorageKeys.Regions);
  }
}
